module.exports = __webpack_public_path__ + "static/media/washington-dc-57.5ed09bcf.jpg";